<template>
  <div class="dynamic-map__wrapper" :class="{ loading: isLoading }">
    <div class="dynamic-map__container" :class="{ loading: isLoading }">
      <map-filter
        v-if="filterOptions && filterOptions.length > 1"
        :checked-list="checkedList"
        :filter-options="filterOptions"
        @updateCheckedList="updateCheckedList"
      />

      <map-component
        :lat="lat"
        :lng="lng"
        :places="filteredPlaces"
        :zoom="zoom"
      />

      <expand-button v-if="windowWidth > 768" />

      <archive-link
        v-if="archiveLink"
        :archive-link="archiveLink"
        :city-slug="city.slug"
      />
    </div>
    <loader :loading="isLoading" />
  </div>
</template>

<script>
  import Loader from "Components/loader/Loader.vue";
  import MapComponent from "Main/components/MapComponent.vue";
  import { parseCoordinate } from "Utils/parseCoordinate";
  import ArchiveLink from "./ArchiveLink.vue";
  import ExpandButton from "./ExpandButton.vue";
  import MapFilter from "./MapFilter.vue";

  export default {
    components: {
      ArchiveLink,
      ExpandButton,
      Loader,
      MapComponent,
      MapFilter,
    },

    computed: {
      filteredPlaces() {
        return this.places.filter((place) => {
          const type = Number.parseInt(place.split("|").pop(), 10);
          if (this.checkedList?.length) {
            return this.checkedList.includes(type);
          }
          return [];
        });
      },
    },

    data() {
      const { dataset } = this.$mountEl;
      return {
        archiveLink: dataset.archiveLink,
        checkedList: window.theme_vars.cityMapData.checkedList,
        city: JSON.parse(dataset.city),
        filterOptions: window.theme_vars.cityMapData.filterOptions,
        id: dataset.id,
        isLoading: true,
        lat: parseCoordinate(dataset.latitude),
        lng: parseCoordinate(dataset.longitude),
        name: dataset.name,
        places: [],
        windowWidth: window.innerWidth,
        zoom: Number(dataset.zoom) || 13,
      };
    },

    methods: {
      getPlaces() {
        fetch(
          `${theme_vars.site_url}/wp-json/lavendla/v1/get-nearby-places-for-map/${this.city.term_id}`
        )
          .then((response) => response.json())
          .then((places) => {
            this.places = places;
            this.isLoading = false;
          });
      },
      updateCheckedList(key) {
        const index = this.checkedList.indexOf(key);

        if (index > -1) {
          this.checkedList.splice(index, 1);
        } else {
          this.checkedList.push(key);
        }
      },
    },

    mounted() {
      this.getPlaces();
    },
    name: "CityMap",
  };
</script>
